import React from "react";
import { createRoot, hydrateRoot } from "react-dom/client";
import { HelmetProvider } from "@dr.pogodin/react-helmet";
import App from "./App";
// import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "./lib/queryClient";

// Initialize AOS (Animate On Scroll)
import AOS from "aos";
import "aos/dist/aos.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
// Initialize AOS
AOS.init({
  duration: 1000,
  once: true,
  offset: 100,
});

const rootEl = document.getElementById("root")!;
const app = (
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <HelmetProvider>
        <App />
      </HelmetProvider>
    </QueryClientProvider>
  </React.StrictMode>
);

// hydrateRoot when react-snap prerendered HTML is present, createRoot otherwise
if (rootEl.hasChildNodes()) {
  hydrateRoot(rootEl, app);
} else {
  createRoot(rootEl).render(app);
}
